import React from "react";
import Lottie from 'react-lottie';
import animationData from 'assets/lotties/many.json';
// reactstrap components
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import {Helmet} from "react-helmet";
// core components
import { useTranslation } from 'react-i18next';

const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};
function Feature2() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
const { t } = useTranslation();

  return (
    <>
        {/* ********* FEATURES 1 ********* */}
        <div className="features-5"
        style={{
          backgroundImage:
            "url(" +
            require("assets/img/pic6.jpeg") +
            ")"}}>
          <Container>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            {/* <Row>
              <Col className="ml-auto mr-auto text-center"  md="11">
                <h2 className="title" style={{color:'navy'}}> <b>QUIENES SOMOS?</b></h2>
                <h5 className="description" style={{color:'navy'}}><b>
                BEACH TOURS S.A.S. es una empresa Colombiana constituida el 04 de julio de 2013 bajo matrícula No 00034619 en Cartagena, luego de que su gerente general, Carlos Borelly, logrará consolidar una experiencia de más de 20 años en el sector de transporte especial y turismo. Habilitada por el Ministerio de Turismo según registro No. 45038 como empresa de turismo en el año 2016.

El principal objetivo de su constitución fue satisfacer las demandas de turismo a nivel empresarial y aquellas generadas por el alto crecimiento económico del departamento.

Actualmente la empresa cuenta con un parque automotor en constante renovación. El personal administrativo, comercial y operativo poseen una amplia experiencia y se encuentran capacitados en la ejecución de actividades relacionadas con el turismo fundamentados en el respeto, responsabilidad y excelentes prácticas logísticas para brindar un servicio de excelencia.
</b>   </h5>
              </Col>
            </Row> */}
            <Row>
              {/* <Col md="6">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-palette" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Beautiful Gallery</h4>
                    <p className="description">
                      Spend your time generating new ideas. You don't have to
                      think of implementing.
                    </p>
                    <Button
                      className="btn-link"
                      color="danger"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      See more
                    </Button>
                  </div>
                </div>
              </Col> */}
              <Helmet>
              <Col md="6">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-bulb-63" />
                  </div>
                  <div className="description" style={{backgroundColor:'#999966', fontWeight:'bolder', color:'navy'}}>
                  <br/>
                  <h4 className="info-title" style={{color:'red'}}><b>{t('description.part7')}</b></h4>
                    <p><b>
                    {t('description.part8')}
                    </b>   </p>
                    <br/>

                    <Button
                      className="btn-link"
                      href="/gallery"
                    >
                    {t('description.part11')}
                    </Button>
                  </div>
                </div>
              </Col>
              
              <meta name="description" content="Professional personnel and modern fleet exceeding expectations. Personal profesional y flota moderna de vehiculos excediendo expectativas"/>

              </Helmet>
              <Col md="6">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-bulb-63" />
                  </div>
                  <div className="description" style={{backgroundColor:'#999966', fontWeight:'bolder', color:'navy'}}>
                  <br/>
                  <h4 className="info-title" style={{color:'red'}}><b>{t('description.part7')}</b></h4>
                    <p><b>
                    {t('description.part8')}
                    </b>   </p>
                    <br/>

                    <Button
                      className="btn-link"
                      href="/gallery"
                    >
                    {t('description.part11')}
                    </Button>
                  </div>
                </div>
              </Col>
              {/* <Col md="6">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-chart-bar-32" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">Statistics</h4>
                    <p>
                      Choose from a veriety of many colors resembling sugar
                      paper pastels.
                    </p>
                    <Button
                      className="btn-link"
                      color="danger"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      See more
                    </Button>
                  </div>
                </div>
              </Col> */}<Helmet>
              <Col md="6">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-sun-fog-29" />
                  </div>
                  <div className="description" style={{backgroundColor:'rgb(153, 153, 102 / 50%)', fontWeight:'bold', color:'navy'}}>
                  <br/>
                  <h4 className="info-title" style={{color:'red'}}><b>                    {t('description.part9')}
                  </b></h4>
                    <p>
                   <b> 
                   {t('description.part10')}
                   </b>
                    </p>
                    <br/>
                    
                    <Button
                      className="btn-link"
                      href="/gallery"
                    >
                                 {t('description.part11')}

                    </Button>
                  </div>
                </div>
              </Col>
              <meta name="description" content="Regional leader in tourism delivering quality, creativity, innovation; competitive and socially responsible. Lider regional en turismo con servicio de calidad, creativo, innovador, competitivo y socialmente responsable"/>

              </Helmet>
              <Col md="6">
                <div className="info">
                  <div className="icon icon-danger">
                    <i className="nc-icon nc-sun-fog-29" />
                  </div>
                  <div className="description" style={{backgroundColor:'#999966', fontWeight:'bold', color:'navy'}}>
                  <br/>
                  <h4 className="info-title" style={{color:'red'}}><b>                    {t('description.part9')}
                  </b></h4>
                    <p>
                   <b> 
                   {t('description.part10')}
                   </b>
                    </p>
                    <br/>
                    
                    <Button
                      className="btn-link"
                      href="/gallery"
                    >
                                 {t('description.part11')}

                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>

          </Container>
        </div>
        {/* ********* END FEATURES 1 ********* */}
        {/* <div
          className="features-5 section-image"
          style={{
            backgroundImage:
              "url(" +
              require("assets/img/groovey.jpg") +
              ")",
          }}
        ><center>
        <Lottie 
options={defaultOptions}
height='400px'
width='50vw'
/></center>
</div> */}
        {/* ********* FEATURES 5 ********* */}
        <div
          className="features-5 section-image"
          style={{
            backgroundImage:
              "url(" +
              require("assets/img/b2.jpeg") +
              ")",
          }}
        >
          <Container>
            <Row>
              <div className="ml-auto mr-auto">
                <h2 className="title text-center">
                {t('description.part12')}
                <b>   </b>
                </h2>
              </div>
            </Row>
            <Row>
              <Col className="ml-auto" sm="5">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-paper" />
                  </div>
                  <h4 className="title">                    {t('description.part13')}
                  </h4>
                  {/* <p>
                    While everyone technically has the feature now, that doesn’t
                    mean you’ll see it all the time. But in this case, the
                    feature wasn’t just randomly A/B tested.
                  </p> */}
                </div>
              </Col>
              <Col className="mr-auto" sm="5">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-ruler-pencil" />
                  </div>
                  <h4 className="title"> {t('description.part14')}</h4>
                  {/* <p>
                    Loveflutter has actually been around for a while, pivoting
                    from matches based on shared interests (innovative!) to now
                    focus on analyzing.
                  </p> */}
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto" sm="5">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-delivery-fast" />
                  </div>
                  <h4 className="title"> {t('description.part15')}</h4>
                  {/* <p>
                    While everyone technically has the feature now, that doesn’t
                    mean you’ll see it all the time. But in this case, the
                    feature wasn’t just randomly A/B tested.
                  </p> */}
                </div>
              </Col>
              <Col className="mr-auto" sm="5">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-bus-front-12" />
                  </div>
                  <h4 className="title"> {t('description.part16')}</h4>
                  {/* <p>
                    Loveflutter has actually been around for a while, pivoting
                    from matches based on shared interests (innovative!) to now
                    focus on analyzing.
                  </p> */}
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto" sm="5">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-map-big" />
                  </div>
                  <h4 className="title"> {t('description.part17')}</h4>
                  {/* <p>
                    While everyone technically has the feature now, that doesn’t
                    mean you’ll see it all the time. But in this case, the
                    feature wasn’t just randomly A/B tested.
                  </p> */}
                </div>
              </Col>
              <Col className="mr-auto" sm="5">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-support-17" />
                  </div>
                  <h4 className="title"> {t('description.part18')}</h4>
                  {/* <p>
                    Loveflutter has actually been around for a while, pivoting
                    from matches based on shared interests (innovative!) to now
                    focus on analyzing.
                  </p> */}
                </div>
              </Col>
            </Row>
            <Row className="bottom-line">
              <Col className="ml-auto" sm="12">
                <div className="info">
                  <div className="icon">
                    <i aria-hidden={true} className="nc-icon nc-world-2" />
                  </div>
                  <h4 className="title"> {t('description.part19')}</h4>
                  {/* <p>
                    As for the user backlash, it comes to the challenges faces
                    in building features to aid newcomers, which can impact its
                    growth and bottom line.
                  </p> */}
                </div>
              </Col>
             
            </Row>
          </Container>
        </div>
        {/* ********* END FEATURES 5 ********* */}
    </>
  );
}

export default Feature2;
